export const setLocalStorageItem = <TValue>(key: string, val: TValue) => {
    if (key) {
        const jsonString = JSON.stringify(val);

        localStorage?.setItem(key, jsonString);
    }
};

export const deleteLocalStorageItem = (key: string): void => localStorage?.removeItem(key);

export const getLocalStorageItem = <TResult>(key: string): TResult | null => {
    const item = localStorage?.getItem(key);
    if (item === null) {
        return null;
    }

    try {
        return JSON.parse(item) as TResult;
    } catch (error) {
        console.error(error);
        return null;
    }
};
